import {
  FETCH_LOAD_SUBTASK_BASED_TEMPLATE_REQUEST,
  FETCH_LOAD_SUBTASK_BASED_TEMPLATE_SUCCESS,
  FETCH_LOAD_SUBTASK_BASED_TEMPLATE_FALUIRE,
} from './loadSubtaskBasedOnTemplateAndProjectTypes'

const initialState = {
  loading: false,
  subTaskBasedOnTemplate: null,
  error: '',
}

const reducer = (state = initialState, action) => {

  switch (action.type) {
    case FETCH_LOAD_SUBTASK_BASED_TEMPLATE_REQUEST : return {
      ...state,
      loading: true,

    }

    case FETCH_LOAD_SUBTASK_BASED_TEMPLATE_SUCCESS : return {
      ...state,
      subTaskBasedOnTemplate: action.payload,
      error: '',
      loading: false,
    }

    case FETCH_LOAD_SUBTASK_BASED_TEMPLATE_FALUIRE : return {
      ...state,
      loading: false,
      subTaskBasedOnTemplate: null,
      error: action.payload,
    }
    default : return state
  }
}

export default reducer
